import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-center-card',
  templateUrl: './call-center-card.component.html',
  styleUrls: ['./call-center-card.component.scss']
})
export class CallCenterCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
